'use strict';

let timeoutID;
let isListening = false;
let queries = [];
const regex = /\((min|max)-(width|height)[\s\t]*[~$^]?:[\s\t]*(\d+)px\)+/gi;
const breakpointSupport = 'getComputedStyle' in window;

function getBreakpoints(css) {
    let match;
    let breakpoints = [];

    while (null !== (match = regex.exec(css))) {
        breakpoints.push({
            'condition': match[1],
            'dimension': match[2],
            'value': match[3]
        });
    }

    return breakpoints;
}

function _matches(query) {
    let isMatch = true;
    let containerWidth = getContainerWidth(query.element);

    for (let i = 0; i < query.breakpoints.length; i++) {
        const breakpoint = query.breakpoints[i];
        if (breakpoint.condition === 'min' && breakpoint.dimension === 'width' && containerWidth >= breakpoint.value) {
            isMatch = true;
        } else if (breakpoint.condition === 'max' && breakpoint.dimension === 'width' && containerWidth <= breakpoint.value) {
            isMatch = true;
        } else {
            isMatch = false;
            break;
        }
    }

    return isMatch;
}

function match(query) {
    const cb = query.cb;
    const matches = _matches(query);

    if (query.isMatched !== matches) {
        query.isMatched = matches;

        if (cb && typeof cb === 'function') {
            cb.call(window, query.name, matches);
        }
    }
}

function isDefault(q) {
    return q.indexOf('!default') > -1;
}

function stripDefault(q) {
  const i = q.indexOf('!default');
  if (i > -1) {
    return q.substr(0, i);
  }

  return q;
}

function getContainerWidth(element) {
    return parseInt(getComputedStyle(element, null).width, 10);
}

function throttle(fn) {
    clearTimeout(timeoutID);
    timeoutID = setTimeout(fn, 50);
}

const handleChange = function () {
    throttle(() => {
        queries.forEach((query) => {
            match(query);
        });
    });
};

module.exports = {
    forceCheck: () => {
        queries.forEach((query) => {
            match(query);
        });
    },

    destroy: (element) => {
        // Find queries to remove
        const queriesToRemove = [];
        queries.forEach((query) => {
            if (query.element === element) {
                queriesToRemove.push(query);
            }
        });

        // Remove queries found above
        queriesToRemove.forEach((query) => {
            const index = queries.indexOf(query);
            if (index !== -1) {
                queries.splice(index, 1);
            }
        });

        // Stop listening if there are no active queries left
        if (queries.length === 0) {
            window.removeEventListener('resize', handleChange, true);
            isListening = false;
            clearTimeout(timeoutID);
        }
    },

    addListener: (element, name, mediaQuery, cb) => {
        if (!breakpointSupport) {
            //if we have a default mediaQuery, make the callback
            if (isDefault(mediaQuery) && cb && typeof cb === 'function') {
                cb.call(window, name, true);
            }

            return;
        }

        queries.push({
            element: element,
            name: name,
            breakpoints: getBreakpoints(stripDefault(mediaQuery)),
            cb: cb,
            isMatched: false
        });

        match(queries[queries.length - 1]);

        if (!isListening) {
            isListening = true;
            window.addEventListener('resize', handleChange, true);
        }
    }
 };



// WEBPACK FOOTER //
// ./src/js/util/breakpoints.js